import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { FirebaseAppProvider, SuspenseWithPerf } from 'reactfire';
// Needed for lazy loaded images
import 'lazysizes';

import { Loading } from '@matematykagryzie/ui';

import { environment } from '../environments/environment';
import { Config } from './config';
import { Routing } from './routing';
import { FirebaseProviders } from './firebase-providers';

export function App() {
  return (
    <HelmetProvider>
      <FirebaseAppProvider
        firebaseConfig={environment.firebaseConfig}
        suspense={true}
      >
        <Config>
          <SuspenseWithPerf
            fallback={<Loading context="Ładowanie aplikacji" />}
            traceId="load_firebase_providers"
          >
            <FirebaseProviders>
              <SuspenseWithPerf
                fallback={<Loading context="Ładowanie treści" />}
                traceId="load_web_app"
              >
                <Routing />
              </SuspenseWithPerf>
            </FirebaseProviders>
          </SuspenseWithPerf>
        </Config>
      </FirebaseAppProvider>
    </HelmetProvider>
  );
}

export default App;
